import React from 'react';
import { ContentSubtitleStyled, ContentTitleStyled, ContentWrapperStyled, HealthQuestionnaireStyled } from './styles';

interface HealthQuestionnaireLayoutProps {
  children: React.ReactNode;
}

export const HealthQuestionnaireLayout: React.FC<HealthQuestionnaireLayoutProps> = ({ children }) => {
  return (
    <ContentWrapperStyled>
      <ContentTitleStyled>Detailed Medical History</ContentTitleStyled>
      <ContentSubtitleStyled>
        Review the information below and make any necessary updates before completing the Health Questionnaire
      </ContentSubtitleStyled>
      <HealthQuestionnaireStyled>{children}</HealthQuestionnaireStyled>
    </ContentWrapperStyled>
  );
};
